module.exports = __webpack_public_path__ + "img/banner-fazer-cotacao.35f8b288.jpg";